export function debouncer<T>(callback: (arg?: T) => void, durationMs: number) {
  let timeout: ReturnType<typeof setTimeout> | null = null

  const cancel = () => {
    if (timeout) {
      clearTimeout(timeout)
      timeout = null
    }
  }

  const debounced = (arg?: T) => {
    cancel()
    timeout = setTimeout(() => callback(arg), durationMs)
  }
  debounced.cancel = cancel

  return debounced
}
